import React, { memo, useCallback } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';

import AccommodationPropertyRoomImagesPanel from './AccommodationPropertyRoomImagesPanel';

interface Props {
  roomId: string;
  roomName?: string | null;
  isExpanded: boolean;
  onExpandedRoomChange: (roomId: string, isExpanded: boolean) => void;
}

function AccommodationPropertyRoomImagesAccordionItem({ roomId, roomName, isExpanded, onExpandedRoomChange }: Props) {
  const roomDisplayName = roomName || `Room ${roomId}`;

  const handleAccordionChange = useCallback(
    (_event: React.SyntheticEvent, nextIsExpanded: boolean) => {
      onExpandedRoomChange(roomId, nextIsExpanded);
    },
    [onExpandedRoomChange, roomId],
  );

  return (
    <Accordion expanded={isExpanded} onChange={handleAccordionChange}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1" fontWeight="medium">
          {roomDisplayName}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <AccommodationPropertyRoomImagesPanel roomId={roomId} roomName={roomDisplayName} isExpanded={isExpanded} />
      </AccordionDetails>
    </Accordion>
  );
}

export default memo(AccommodationPropertyRoomImagesAccordionItem);
